<template>
  <div class="contact-table">
    <component :is="renderTag" :href="renderHref" class="bg-cont-dim d-grid grid-1-2 contact-row" target="_blank" rel="noreferrer nofollow">
      <div class="contact-title d-flex text-b14 gap-5 color-on-cont-dim text-medium" v-if="renderIcon !== null">
        <span class="icon d-flex gap-4 leaning-24" :class="{ 'email-icon items-center': type === 'email' }">
          <Icons :name="renderIcon" />
          <span class="d-flex leaning-24" :class="{ 'email-icon ': type === 'email' }">
            {{ renderTitle }}
          </span>
        </span>
      </div>
      <div class="contact-value leaning-24 d-flex items-center color-on-cont-bright text-b14">{{ renderValue }}</div>
    </component>
  </div>
</template>

<script lang="ts" setup>
import { computed, toRefs } from 'vue';
import Icons from '@/components/base/icon/index.vue';

interface ContactDataInfo {
  value: string;
  type: 'address' | 'phone' | 'email';
}

const props = defineProps<ContactDataInfo>();
const { value, type } = toRefs(props);

const renderIcon = computed(() => type.value || null);
const renderTitle = computed(() => {
  switch (type.value) {
    case 'address':
      return 'آدرس';
    case 'email':
      return 'ایمیل';
    case 'phone':
      return 'تلفن';
    default:
      return '';
  }
});

const renderValue = computed(() => value.value);
const renderHref = computed(() => {
  if (type.value === 'email') return `mailto:${value.value}`;
  if (type.value === 'phone') return `tel:${value.value}`;
  return undefined;
});
const renderTag = computed(() => (type.value !== 'address' ? 'a' : 'div'));
</script>

<style lang="scss" scoped>
@import url('./contact-merchant.scss');
</style>
